import { App, Plugin, Directive } from 'vue'
import * as Maska from 'maska'

const MaskaDirective = Maska as unknown as Directive

const MaskaPlugin: Plugin = {
  install(app: App) {
    app.directive('maska', MaskaDirective)
  }
}

export default MaskaPlugin
